// extracted by mini-css-extract-plugin
export const root = "J_bz";
export const border = "J_cq";
export const validated = "J_cr";